import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ApiService } from '../../lib/api.service';
import { StorageService } from '../../lib/storage.service';
import { LogService } from '../../lib/log.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ModalService } from '../../lib/modal.service';
import { AssessmentAlert } from '../../components/assessment-alert/assessment-alert';
import { AssessmentResilienceAlert } from '../../components/assessment-resilience-alert/assessment-resilience-alert';
import { User } from '../../../app/models/user';
import { Organization } from '../../../app/models/organization';
import { Assessment } from '../../../app/models/assessment';
import { UserService } from '../../../app/lib/user.service';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import * as jQuery from 'jquery';
import { Subscription } from 'rxjs';
import { AssessmentService } from 'app/lib/assessment.service';
import { AnalyticEvent } from 'app/lib/analytic-event';
import { AssessmentStateService } from '../../lib/assessment-state.service';

@Component({
    selector: 'app-crafft-assessment',
    templateUrl: './crafft-assessment.component.html',
    styleUrls: ['./crafft-assessment.component.scss'],
    standalone: false
})
export class CrafftAssessmentComponent implements OnInit {

    isLoaded = false;
    questions: Array<any> = [];
    assessmentQuestions: Array<any> = [];
    resourceQuestion = {};
    active = 0;
    count = 0;
    alerts: string;
    user: User;
    popup: any;
    quizType: string = "crafft";
    showIntro: boolean = true;
    assessment: Assessment;
    organization: Organization;
    forced: boolean;
    submitting: boolean;
    title: string;
    back: string;
    backLink: string;
    cssClass: string;
    alert: boolean;
    buffer = 0;
    progress = 0;
    progressValue: any;
    optionType: any;
    showAnimation: boolean = false;
    typeAssessment: string;
    assessmenttranslation: any;
    returnPath: any;
    showEmptyHeader: boolean = false;
    initalAssessmentQuestionIndex: number = -1;
    selectedStarIndex: number = 0;
    rating: number = 0;
    textAreaValue = '';
    endUserId: any;
    popups: any;
    enabledQuestions: Array<any> = [];
    activeQuestionNumber: number = 1;
    resetAssessmentQtn: boolean;
    constructor(
        private api: ApiService,
        private modalService: ModalService,
        private log: LogService,
        private storage: StorageService,
        private router: Router,
        private userService: UserService,
        private activatedRoute: ActivatedRoute,
        private translate: TranslateService,
        private route: ActivatedRoute,
        private location: Location,
        public assessmentService: AssessmentService,
        private assessmentState: AssessmentStateService
        
    ) {
        this.user = this.userService.getUser();
        this.submitting = false;
        this.route.queryParams.subscribe(params => {
            this.endUserId = params['userId'];
        });
    }

    ngOnInit() {
        this.getTranslations();       
        this.getQuestions();
        this.assessmentState.setAssessmentActive(true);
    }

    getTranslations() {
        this.translate.stream('error').subscribe((res: any) => {
            this.popup = res.title;
        });
        this.translate
            .stream('dynamicAssessment.crafft.popup')
            .subscribe((res: any) => {
                this.popups = res;
            });
        this.activatedRoute.params.subscribe((params: Params) => {
            if (params['assessment']) {
                this.quizType = params['assessment'];
            }
            this.translate
                .stream('assessments.' + this.quizType)
                .subscribe((res: any) => {
                    this.assessmenttranslation = res;
                    this.title = res.title;
                    this.back = res.back;
                });

            if (this.quizType === 'crafft') {
                this.activatedRoute.queryParams.subscribe(queryParams => {
                    this.forced = queryParams['forced'];
                    this.returnPath = queryParams['path'];
                });
                if (this.returnPath === 'onboarding') {
                    this.showEmptyHeader = true;
                }
            }
        });
    }

    getQuestions() {
    this.isLoaded = false;
     this.questions = [];
        this.api.get('form/' + this.user.crafftFormID).subscribe(
            (result: any) => {
                let questionslist = result.data;
                this.setAssessmentQuestionData(questionslist);
                if (
                    this.user.primaryOrganization &&
                    this.user.primaryOrganization.id &&
                    this.quizType === 'crafft'
                ) {
                    this.getResourceQuestions();
                } else {
                    this.isLoaded = true;
                }
            },
            (error: any) => {
                this.isLoaded = true;
                this.log.event(
                    AnalyticEvent.event.assessmentQuestionsFetchError
                );
                this.log.error(
                    'Error getting assessment questions. ' + error.message
                );
            }
        );
    }

    getResourceQuestions() {
        this.api
            .get(
                'organizations/' + this.user.primaryOrganization.id
            )
            .subscribe(
                (result: any) => {
                    this.isLoaded = true;
                    this.organization = new Organization(
                        result.data,
                        'view'
                    );
                    this.orgQuestions();
                },
                (error: any) => {
                    this.isLoaded = true;
                    this.log.error(
                        'Error getting organizations. ' +
                        error.message
                    );
                }
            );
    }

    setAssessmentQuestionData(questionsList: any[]): void {
        questionsList.forEach((questionArr: any[], questionIndex: number) => {
            const question = questionArr[0];
            question.questionType = "assessmentQuestion";
            question.isAnswered = false;
            question.isEnabled = true;
            question.answer = {
                answerType: "assessmentAnswer",
                isAnswered: false,
                value: question.Type === 5 ? "" : -1,
                values: {},
                name:
                    question.Type === 5 && question.options?.length
                        ? question.options[0].ID
                        : -1,
                id: question.ID,
                type: question.Type,
                isEnabled: true,
                Group: question.Group,
                fieldDisabled: false,
            }
            if (Array.isArray(question.options)) {
                question.options.forEach((option: any) => {
                    option.checked = false;
                });
            }
            if (question.Group === "intro-question-crafft") {
                this.questions.push(question);
            } else if (question.Group === "assessment-question") {
                this.assessmentQuestions.push(question);
            }
            if (question.Group === "assessment-question" && this.initalAssessmentQuestionIndex === -1)
            {
                this.initalAssessmentQuestionIndex = questionIndex;
            }
        });
    }

    orgQuestions() {
        // for each on question set.  loop and add answers
        let lang = this.getLangForResourceList();
        if (
            this.organization.resourceSet.length &&
            this.organization.enableResources
        ) {
            let resourcesQuestions = [];
            this.organization.resourceSet.forEach(qs => {
                if (qs.language == lang) {
                    resourcesQuestions.push({
                        ID: qs.id,
                        QuestionID: "",
                        OptionValue: 0,
                        Comment: qs.title,
                        checked: false,
                        type: 3,
                    });
                }
            });
            if (resourcesQuestions.length) {
                resourcesQuestions.push({
                    ID: "none",
                    QuestionID: "",
                    OptionValue: 0,
                    Comment: "None",
                    checked: false,
                    type: 3,
                });
                this.resourceQuestion = {
                    questionType: "resourceQuestion",
                    isAnswered: false,
                    isEnabled: true,
                    options: resourcesQuestions,
                    ID: "",
                    QuizID: "",
                    Comment: this.translate.instant("das.resourceQuestionTitle"),
                    Group: "resource-question",
                    Type: 3,
                    Active: 1,
                    answer: {
                        answerType: "resourceAnswer",
                        isAnswered: false,
                        isEnabled: true,
                        value: -1,
                        values: resourcesQuestions,
                        name: -1,
                        id: "",
                        fieldDisabled: false,
                        type: "resource-question",
                    },
                };
            }
        }
    }


    getLangForResourceList() {
        let selectedLang = this.storage.get('lang');
        if (
            (selectedLang === 'fr' || selectedLang === 'es') &&
            !this.hasResourceByLangage(selectedLang)
        ) {
            selectedLang = 'en';
        }
        return selectedLang;
    }

    hasResourceByLangage(lang: string): boolean {
        return this.organization.resourceSet.some(r => r['language'] === lang);
    }

    generateAnswerData(questionData) {
    let answers = [];
    questionData.forEach((question) => {
      if (question.answer.answerType == "assessmentAnswer") {
        if (question.answer.Group !== "assessment-question" || question.answer.isEnabled) {
          answers.push(question.answer);
        }
      } else if (question.answer.answerType == "resourceAnswer" && question.answer.isAnswered) {
        question.options.forEach((item) => {
          if (item.ID !== "none") {
            let resourceAnwer = {
              answerType: "resourceAnswer",
              isAnswered: item.checked ? true : false,
              value: item.checked ? 1 : 0,
              values: {},
              name: -1,
              id: item.ID,
              type: item.type,
            };
            answers.push(resourceAnwer);
          }
        });
      }
    });
    return answers;
  }

    onSubmit() {
        this.assessmentState.setAssessmentActive(false);
         let answerData = this.generateAnswerData([...this.questions]);
        this.submitting = true;
        this.showAnimation = true;
        this.api
            .post('assessment/save', {
                Type: this.quizType,
                Data: JSON.stringify(answerData),
                OrgQuestions: {},
            })
            .subscribe(
                (results: any) => {
                    this.api.get('users/me').subscribe(
                        (result: any) => {
                            this.showAnimation = false;
                            this.assessment = new Assessment(results.data);
                            this.log.event(
                                AnalyticEvent.event
                                    .crafftAssessmentSubmitted
                            );
                            this.router.navigate([
                                '/app/assessment/result',
                                this.assessment.id,
                                this.assessment.type,
                            ]);
                            this.submitting = false;
                        },
                        (error: any) => {
                            this.log.event(
                                AnalyticEvent.event.assessmentSubmitError
                            );
                            this.log.error(
                                'Error fetching user profile: ' + error.message
                            );
                        }
                    );
                },
                (error: any) => {
                    this.log.event(AnalyticEvent.event.assessmentSubmitError);
                    this.modalService.showAlert(this.popup, error.message);
                    this.log.error('Error registering. ' + error.message);
                    this.submitting = false;
                }
            );
    }

    scrollToTop() {
        let element = document.getElementById('page-assessment');
        element.scrollIntoView();
    }

    setNextActive() {
        this.resetAssessmentQtn && this.enableOrDisableAssessmentQuestions();
        this.active = this.active + 1;
        this.showIntro = false;
    }

    setIntro(intro) {
        this.showIntro = intro;
    }

    setPreviousActive() {
       this.showIntro = false;
       this.active = this.active - 1;
  
    }

    isSelected(index: number, optionID: string): boolean {
        return (
            this.questions[index].answer["value"] !== undefined &&
             this.questions[index].answer["value"] !== 0
        );
    }

    isShowNextBtn(): boolean {
        if (this.questions[this.active].Group === "intro-question-crafft") {
            return true;
        } else {
            return this.active < this.questions.length - 1;
        }
    }

    isShowFinishBtn(): boolean {
        if (this.questions[this.active].Group === "intro-question-crafft") {
            return false;
        } else {
            return this.active === this.questions.length - 1;
        }
    }

    enableOrDisableAssessmentQuestions(): void {
        if (this.active === this.initalAssessmentQuestionIndex - 1) {
            const introQuestions = this.questions.filter(
                (a) => a.Group === "intro-question-crafft"
            );
            const hasAnyPositiveIntro = introQuestions.some(
                (qtn) => qtn.answer.value >= 1
            );
            this.questions.splice(this.initalAssessmentQuestionIndex);
            if (hasAnyPositiveIntro) {
                this.assessmentQuestions.forEach((qtn) => {
                    this.questions.push(JSON.parse(JSON.stringify(qtn)));
                });
                this.modalService.showAlert(this.popups.thanks, this.popups.continueCrafftAssessmentBody);
            } else {
                this.questions.push(
                    JSON.parse(JSON.stringify(this.assessmentQuestions[0]))
                );
            }
            if (
                this.user?.primaryOrganization &&
                this.organization?.resourceSet?.length &&
                this.organization?.enableResources
            ) {
                this.questions.push(JSON.parse(JSON.stringify(this.resourceQuestion)));
            }
            this.resetAssessmentQtn = false;
        }
    }

    /*
        question position, answer position,  type of question (1,2), question ID
        type 1: single answer
        type 2: multiple answers
        type 3: yes/no
        "onSelectionChange(i, option.OptionValue, question, option.ID)"
    */
    onSelectionChange(i: number, value: any, question: any, optionID: string, fulloption?) {
        let answer = question.answer;
        switch (question.Type) {
      case 1: {
        let optionValue = value;
        answer["value"] = optionValue;
        answer["name"] = optionID;
        question.isAnswered = answer.isAnswered = true;
        setTimeout(() => {
            this.setNextActive();
          }, 100);
        break;
      }
      case 2: {
        let optionValue = value;
        if (
          answer["values"].hasOwnProperty(optionValue.ID)
        ) {
          delete answer["values"][optionValue.ID];
        } else {
          answer["values"][optionValue.ID] =
            optionValue.OptionValue;
        }
        optionValue.checked = !optionValue.checked;
        question.isAnswered = answer.isAnswered =
          Object.keys(answer["values"]).length > 0
            ? true
            : false;
        break;
      }
      case 5: {
        answer.value = value;
        answer["name"] =
          this.questions[this.active].options[0].ID;
        question.isAnswered = answer.isAnswered = 
        answer.value
          ? true
          : false;
        break;
      }
      case 3: {
        const optionData = fulloption;
        if (optionData.ID === "none") {
          question.options.forEach((item) => {
            if (item.ID !== "none") {
              item.OptionValue = 0;
              item.checked = false;
            }
          });
        } else {
          question.options.forEach((item) => {
            if (item.ID == "none") {
              item.checked = false;
            }
          });
        }
        optionData.checked = !optionData.checked;
        question.isAnswered = answer.isAnswered = question.options.some((item) => item.checked);
        break;
      }
      case 8: {
        const inputValue = value;
        const optionValue = Number(inputValue);
        const isValid = inputValue !== "" && !isNaN(optionValue) && optionValue >= 0;
        answer.value = isValid ? optionValue : -1;
        answer["name"] = isValid
          ? question.options[0].ID : -1;
        question.isAnswered = answer.isAnswered = isValid;
        this.resetAssessmentQtn = isValid;
        break;
      }

        // Only increment the buffer the first time the question is marked as answered
        // if (this.answers[i].isAnswered && this.answers[i].bufferIncremented !== true) {
        //     this.buffer += this.progressValue;
        //     this.answers[i].bufferIncremented = true; // Avoid re-incrementing
        // };
    }
}

    checkAllAnswered() {
        let hasItem = this.questions.some((item) => item.isAnswered == false);
        return hasItem ? false : true;
    }

    onCancel() {
        this.router.navigate(['/app/assessment/crafft/listing']);
    }

    goBack() {
        this.router.navigate(['/app/assessment/crafft/listing']);
        
    }

    backList() {
        this.modalService
            .showConfirmation(
                this.popups.exit,
                this.popups.exitMsg,
                this.popups.yes,
                this.popups.no
            )
            .afterClosed()
            .subscribe(result => {
                if (result) {
                    this.isLoaded = false;
                    if (this.user.userType != 'user' && this.endUserId) {
                        let url =
                            '/professional/user-details-dashboard/' +
                            this.endUserId;
                        this.router.navigate([url]);
                    } else {
                        let url =
                            '/app/assessment/' + this.quizType + '/listing';
                        this.router.navigate([url]);
                    }
                }
            });
    }
}

